import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "supplyTotal",              // supply total from last supply (hidden input)
    "salePrice",                // sale price input
    "earningPrice",             // calculated earning per item (read-only)
    "earningPercentageDisplay", // calculated earning percentage display (read-only)
    "stock"                     // stock quantity input
  ]

  connect() {
    this.calculatePrices()
  }

  calculatePrices() {
    // Get supply total from hidden input (set from last supply's unit cost)
    const supplyTotal = this.hasSupplyTotalTarget ? (parseFloat(this.supplyTotalTarget.value) || 0) : 0

    // Calculate earning price per item
    const salePrice = parseFloat(this.salePriceTarget.value) || 0
    const earning = salePrice - supplyTotal

    // Update earning per item display
    this.earningPriceTarget.value = earning.toFixed(2)

    // Calculate earning percentage per item (earning / supply * 100)
    const earningPercentage = supplyTotal > 0 ? (earning / supplyTotal * 100) : 0
    if (this.hasEarningPercentageDisplayTarget) {
      if (this.earningPercentageDisplayTarget.tagName === 'INPUT') {
        this.earningPercentageDisplayTarget.value = `(${Math.ceil(earningPercentage)}%)`
      } else {
        this.earningPercentageDisplayTarget.textContent = `(${Math.ceil(earningPercentage)}%)`
      }
    }

    // Visual feedback if sale < supply
    if (salePrice > 0 && salePrice < supplyTotal) {
      this.salePriceTarget.classList.add('border-red-500')
      this.earningPriceTarget.classList.add('text-red-600')
      if (this.hasEarningPercentageDisplayTarget && this.earningPercentageDisplayTarget.tagName !== 'INPUT') {
        this.earningPercentageDisplayTarget.classList.add('text-red-600')
      }
    } else {
      this.salePriceTarget.classList.remove('border-red-500')
      this.earningPriceTarget.classList.remove('text-red-600')
      if (this.hasEarningPercentageDisplayTarget && this.earningPercentageDisplayTarget.tagName !== 'INPUT') {
        this.earningPercentageDisplayTarget.classList.remove('text-red-600')
      }

      // Show positive earning in green
      if (earning > 0) {
        this.earningPriceTarget.classList.add('text-green-600')
        if (this.hasEarningPercentageDisplayTarget && this.earningPercentageDisplayTarget.tagName !== 'INPUT') {
          this.earningPercentageDisplayTarget.classList.add('text-green-600')
        }
      } else {
        this.earningPriceTarget.classList.remove('text-green-600')
        if (this.hasEarningPercentageDisplayTarget && this.earningPercentageDisplayTarget.tagName !== 'INPUT') {
          this.earningPercentageDisplayTarget.classList.remove('text-green-600')
        }
      }
    }
  }
}
